export default __webpack_public_path__ + "static/media/upward-growth-bar-graph-icon.a707c715.svg";